var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded-full items-center justify-center",class:{ 'inline-flex': !_vm.hideOnMobile, 'hidden': _vm.hideOnMobile }},[_c('img',{attrs:{"src":'/img/icons/' + _vm.name + '.svg'}})])}
var staticRenderFns = []

export { render, staticRenderFns }